import { render, staticRenderFns } from "./pallarax-component.vue?vue&type=template&id=56df63a1&scoped=true&"
import script from "./pallarax-component.vue?vue&type=script&lang=js&"
export * from "./pallarax-component.vue?vue&type=script&lang=js&"
import style0 from "./pallarax-component.vue?vue&type=style&index=0&id=56df63a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56df63a1",
  null
  
)

export default component.exports